// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar - Premium Dark Theme with Colorful Icons */
.sidebar {
  width: 200px;
  height: 100dvh;
  position: fixed;
  top: 0;
  left: 0;
  background: #1a1b23;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);
  transition: width 0.3s ease;
  overflow: hidden;
  z-index: 100;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar.collapsed {
  width: 48px;
}

/* Sidebar Header */
.sidebar-header {
  padding: 10px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-shrink: 0;
}

.sidebar-title {
  overflow: hidden;
  white-space: nowrap;
  padding-left: 4px;
}

.sidebar.collapsed .sidebar-title {
  display: none;
}

.sidebar-brand {
  font-size: 15px;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: -0.3px;
}

.sidebar-subtitle {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  display: block;
  margin-top: 2px;
}

.sidebar-toggle {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
}

.sidebar.collapsed .sidebar-toggle {
  margin: 0 auto;
}

/* Sidebar Navigation */
.sidebar-nav {
  flex: 1 1;
  padding: 6px 6px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  overflow-y: auto;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.15s ease;
  text-align: left;
  width: 100%;
  position: relative;
  border-left: 2px solid transparent;
}

.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.85);
}

.sidebar-item.active {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-weight: 600;
  border-left-color: #4ade80;
}

/* Colorful Icons per nav item */
.sidebar-item:nth-child(1) .sidebar-icon {
  color: #4ade80;
}

.sidebar-item:nth-child(2) .sidebar-icon {
  color: #fbbf24;
}

.sidebar-item:nth-child(3) .sidebar-icon {
  color: #c084fc;
}

.sidebar-item.active .sidebar-icon {
  filter: brightness(1.2);
}

/* Sidebar Icons */
.sidebar-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sidebar-icon svg {
  width: 18px;
  height: 18px;
}

/* Sidebar text */
.sidebar-text {
  white-space: nowrap;
  overflow: hidden;
  font-size: 13px;
}

/* Collapsed sidebar nav */
.sidebar.collapsed .sidebar-item {
  justify-content: center;
  padding: 8px 4px;
  border-left: none;
  border-bottom: 2px solid transparent;
}

.sidebar.collapsed .sidebar-item.active {
  border-bottom-color: #4ade80;
  border-left-color: transparent;
}

.sidebar.collapsed .sidebar-text {
  display: none;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 8px 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
}

.user-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-icon svg {
  width: 18px;
  height: 18px;
}

.user-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 12px;
  font-weight: 500;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.8);
}

.logout-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logout-icon svg {
  width: 18px;
  height: 18px;
}

/* Collapsed sidebar footer */
.sidebar.collapsed .user-info {
  justify-content: center;
  padding: 8px;
}

.sidebar.collapsed .user-name {
  display: none;
}

.sidebar.collapsed .logout-button {
  justify-content: center;
  padding: 8px;
}

/* Mobile responsive */
@media (max-height: 600px) {
  .sidebar-header {
    padding: 6px 8px;
  }

  .sidebar-nav {
    padding: 4px 6px;
    gap: 0;
  }

  .sidebar-item {
    padding: 7px 10px;
  }

  .sidebar-footer {
    padding: 4px 6px;
  }

  .user-info {
    padding: 4px 10px;
  }

  .logout-button {
    padding: 6px 10px;
  }

  .sidebar.collapsed .sidebar-item {
    padding: 6px;
  }

  .sidebar.collapsed .user-info {
    padding: 4px;
  }

  .sidebar.collapsed .logout-button {
    padding: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,uFAAuF;EACvF,iDAAiD;AACnD;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,MAAM;EACR;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Sidebar - Premium Dark Theme with Colorful Icons */\n.sidebar {\n  width: 200px;\n  height: 100dvh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: #1a1b23;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);\n  transition: width 0.3s ease;\n  overflow: hidden;\n  z-index: 100;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  border-right: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.sidebar.collapsed {\n  width: 48px;\n}\n\n/* Sidebar Header */\n.sidebar-header {\n  padding: 10px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.sidebar-title {\n  overflow: hidden;\n  white-space: nowrap;\n  padding-left: 4px;\n}\n\n.sidebar.collapsed .sidebar-title {\n  display: none;\n}\n\n.sidebar-brand {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f8fafc;\n  letter-spacing: -0.3px;\n}\n\n.sidebar-subtitle {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  display: block;\n  margin-top: 2px;\n}\n\n.sidebar-toggle {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.5);\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.sidebar.collapsed .sidebar-toggle {\n  margin: 0 auto;\n}\n\n/* Sidebar Navigation */\n.sidebar-nav {\n  flex: 1;\n  padding: 6px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  overflow-y: auto;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.55);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.15s ease;\n  text-align: left;\n  width: 100%;\n  position: relative;\n  border-left: 2px solid transparent;\n}\n\n.sidebar-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.sidebar-item.active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n  font-weight: 600;\n  border-left-color: #4ade80;\n}\n\n/* Colorful Icons per nav item */\n.sidebar-item:nth-child(1) .sidebar-icon {\n  color: #4ade80;\n}\n\n.sidebar-item:nth-child(2) .sidebar-icon {\n  color: #fbbf24;\n}\n\n.sidebar-item:nth-child(3) .sidebar-icon {\n  color: #c084fc;\n}\n\n.sidebar-item.active .sidebar-icon {\n  filter: brightness(1.2);\n}\n\n/* Sidebar Icons */\n.sidebar-icon {\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.sidebar-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Sidebar text */\n.sidebar-text {\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 13px;\n}\n\n/* Collapsed sidebar nav */\n.sidebar.collapsed .sidebar-item {\n  justify-content: center;\n  padding: 8px 4px;\n  border-left: none;\n  border-bottom: 2px solid transparent;\n}\n\n.sidebar.collapsed .sidebar-item.active {\n  border-bottom-color: #4ade80;\n  border-left-color: transparent;\n}\n\n.sidebar.collapsed .sidebar-text {\n  display: none;\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 8px 6px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  color: rgba(255, 255, 255, 0.45);\n  font-size: 12px;\n}\n\n.user-icon {\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.user-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.user-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.logout-button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.5);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.logout-button:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.logout-icon {\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.logout-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Collapsed sidebar footer */\n.sidebar.collapsed .user-info {\n  justify-content: center;\n  padding: 8px;\n}\n\n.sidebar.collapsed .user-name {\n  display: none;\n}\n\n.sidebar.collapsed .logout-button {\n  justify-content: center;\n  padding: 8px;\n}\n\n/* Mobile responsive */\n@media (max-height: 600px) {\n  .sidebar-header {\n    padding: 6px 8px;\n  }\n\n  .sidebar-nav {\n    padding: 4px 6px;\n    gap: 0;\n  }\n\n  .sidebar-item {\n    padding: 7px 10px;\n  }\n\n  .sidebar-footer {\n    padding: 4px 6px;\n  }\n\n  .user-info {\n    padding: 4px 10px;\n  }\n\n  .logout-button {\n    padding: 6px 10px;\n  }\n\n  .sidebar.collapsed .sidebar-item {\n    padding: 6px;\n  }\n\n  .sidebar.collapsed .user-info {\n    padding: 4px;\n  }\n\n  .sidebar.collapsed .logout-button {\n    padding: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
